import { render, staticRenderFns } from "./FactoryIcon.vue?vue&type=template&id=2c62fe89"
import script from "./FactoryIcon.vue?vue&type=script&lang=js"
export * from "./FactoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports